/**
 * Copyright 2020 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const deletePlan = `mutation DeletePlan($customer_id: String!, $id: String!) {
    deletePlan(customer_id: $customer_id, id: $id)
  }
  `;
